import s from './student-card.module.scss'
import classNames from 'classnames';
import { IconCalendar, IconClockHour8, IconSquareRoundedX } from '@tabler/icons-react';
import { useStudentModal } from '@features/teacher/student/model/use-student-modal';
import { getFullName } from '@utils/lib/getFullname';
import { AnimatedCard } from '@shared/ui/animated-card/animated-card';

export const StudentCard = ({isRegistered, id, date, student, student_email, months}) => {
	const { open: openModal } = useStudentModal()

	return (
		<AnimatedCard layoutId={'student-' + id}>
			<div
				onClick={() => {
					if (isRegistered) {
						openModal({ studentId: id });
					}
				}}
				className={s.studentCard}
				key={'student_' + id}
			>
				<div className={s.avatar}>
					<img
						src={
							student?.avatar
								? process.env.REACT_APP_STORAGE_URL +
									student?.avatar?.image
								: process.env.REACT_APP_STORAGE_URL +
									"images/default_avatar.png"
						}
						alt=""
					/>
				</div>
				<div className={s.content}>
					<div className={s.name}>
						{isRegistered ? getFullName(student) : student_email}
					</div>
					<div className={classNames(s.badge, student?.upcoming_appointment ? s.active : '')}>
						{isRegistered ? 
						(student?.upcoming_appointment ? 
						<><IconCalendar size={12}/> Занятие {date.getDate() + " " + months[date.getMonth()]}</> :
						<><IconSquareRoundedX size={12}/> Нет занятий</>) : 
						<><IconClockHour8 size={12}/> В ожидании</>}
					</div>
				</div>
			</div>
		</AnimatedCard>
	)
}
